export default __webpack_public_path__ + "static/media/GreenFrame05.88e6018b.png";